import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { ShieldAlert } from "lucide-react";
import { lightThemeColors } from "../../assets/styles/colors";

const DismissibleInfoBanner = ({ text, cookieKey }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const dismissed = document.cookie
      .split("; ")
      .find((row) => row.startsWith(`${cookieKey}=`));
    if (dismissed) setVisible(false);
  }, [cookieKey]);

  const handleDismiss = () => {
    setVisible(false);
    const expiryDate = new Date();
    expiryDate.setFullYear(expiryDate.getFullYear() + 1);
    document.cookie = `${cookieKey}=true; expires=${expiryDate.toUTCString()}; path=/`;
  };

  if (!visible) return null;

  return (
    <InfoBanner>
      <ShieldAlert size={16} color="#6b7280" style={{ flexShrink: 0, marginTop: 2 }} />
      <BannerContent>
        <BannerText>{text}</BannerText>
      </BannerContent>
      <BannerActions>
        <DismissButton onClick={handleDismiss}>Dismiss</DismissButton>
      </BannerActions>
    </InfoBanner>
  );
};

export default DismissibleInfoBanner;

const InfoBanner = styled.div`
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 12px 16px;
  display: flex;
  align-items: flex-start;
  gap: 10px;
`;

const BannerContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
  min-width: 0;
`;

const BannerText = styled.p`
  color: ${lightThemeColors.darkColor};
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  margin: 0;
`;

const BannerActions = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`;

const DismissButton = styled.button`
  background: none;
  border: none;
  color: #6b7280;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  padding: 0;
  text-decoration: none;
  transition: color 0.2s;

  &:hover {
    color: ${lightThemeColors.darkColor};
  }
`;
